(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadSources(video) {
    if (video.dataset.lazyLoaded === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      if (sources[i].dataset.src) {
        sources[i].src = sources[i].dataset.src;
      }
    }
    video.dataset.lazyLoaded = 'true';
    video.load();
  }

  function playVideo(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        /* autoplay can be blocked; ignore silently */
      });
    }
  }

  function activate(video) {
    loadSources(video);
    if (!reduceMotion && video.hasAttribute('data-autoplay')) {
      // iOS requires the muted property (not just the attribute) for JS-triggered autoplay.
      video.muted = true;
      playVideo(video);
    }
  }

  var observer = null;

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            activate(video);
          } else if (video.dataset.lazyLoaded === 'true' && !video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.1 }
    );
  }

  function observeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll('video[data-lazy-video]:not([data-lazy-observed])');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      video.setAttribute('data-lazy-observed', 'true');
      if (observer) {
        observer.observe(video);
      } else {
        // No IntersectionObserver support: just load + play.
        activate(video);
      }
    }
  }

  function init() {
    observeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when Shopify loads/reorders sections in the theme editor
  // and expose a manual hook for dynamically injected content.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
  window.lazyVideoObserveAll = observeAll;
})();
